
import { useRef, useState , useEffect, Fragment } from "react";
import Config from "../../../Config";
import InputText from "../../../helpers/InputText";
import InputTextArea from "../../../helpers/InputTextArea";
import InputUploader from "../../../helpers/InputUploader";

import back from "../../../back.png";
import { useActionState } from "react";
import InputCombo from "../../../helpers/InputCombo";

function NewMsg(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [recpientsTab, setRecpiensTab] = useState(null);

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        odbiorcy: [],
        temat: "Pytanie",
        tresc:"",
        files: [],
    });

    var tmpFiles = [];

    var [clearFlag, setClearFlag] = useState(1);





    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };

 


    const valChangeListener = (filedName, val, correct, msg) => { 
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      

        if(filedName == "odbiorca" )
        {
            var odb = new Array();
            odb.push({
                px_group_id: val,         
                p_dziecko_id: -2,       //ustaw moje..
            });
            setRow( {...row, ["odbiorcy"]:odb,  [filedName+"_valid"]:correct  } ); 
            return;
        }
 
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         
    }



    
    const goNextNew = () => {
        console.log("goNext");
        goSend();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const goClear = () => {


        setRow({
            odbiorcy: [],    
            temat:"",
            tresc:"",
            files: [],
        });

        setClearFlag( clearFlag +1 );
    }

    

    const goSend = ()  => {


        if(row.odbiorcy.length < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz odbiorców wiadomości"  ,  "ok"  ,null); 
            return;
        }


        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


 

        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_msg,send', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                 
                            goClear();

                            props.mainView.showDialog( "Sukces", "Wysłano wiadomości: " + res.result , "ok" , null);  
 
                            props.mainView.clickMenu("msg","sended","-1");
 

                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }


    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload: " + fileName + " " + crypt);
       // goParse(crypt);

  
         tmpFiles.push({
            fileName: fileName,
            crypt: crypt
        });
 
        setRow(  {...row, ["files"]: tmpFiles  } );
    }

    

    const goDeleteAttach = (e) => {

        var crypt  =  e.target.getAttribute("atr-crypt");
        var typ    =  e.target.getAttribute("atr-typ");
        var typId  =  e.target.getAttribute("atr-typId");

        
        var req = {
            id: -1,
            crypt: crypt,
            typ: typ,
            typ_id: typId,
        }


        props.mainView.setProgress(-2);

    
        fetch( Config.url + '/rest_v1,del_by', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
               
                           var newTmp = new Array();

                           for(var k=0; k<row.files.length; k++)
                           {                              
                                if(row.files[k].crypt == crypt  ) continue; 
                                newTmp.push( row.files[k] );
                           }

                           setRow({...row, ["files"]: newTmp  } );
                           

                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }



    const getRecipients = ()  => {
 
        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_msg,recipient_p', {  
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                            setRecpiensTab(res.result);                                                                                                        
                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }






   if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        goClear();
        setRecpiensTab(null);
    }

 

    if(recpientsTab == null)
    {
        setRecpiensTab([]);
        getRecipients();
    }




    var itemsRecpiens = [
            {
                v: '_x_',
                title: 'Wybierz odbiorcę'
            }
    ];

    if(  recpientsTab != null &&  recpientsTab.opiekunowie != undefined )
    {
        for(var k=0; k < recpientsTab.opiekunowie.length; k++ )
            {
                  itemsRecpiens.push(
                    {
                        v: recpientsTab.opiekunowie[k]["id"],
                        title: recpientsTab.opiekunowie[k]["nazwisko"] + " " + recpientsTab.opiekunowie[k]["imie"] + " (" +  recpientsTab.opiekunowie[k]["stanowisko"] + ")",
                    }
                  );
            }
    }  

    if(  recpientsTab != null &&  recpientsTab.grupy != undefined )
        {
            for(var k=0; k < recpientsTab.grupy.length; k++ )
                {
                     
                        for(var g=0; g < recpientsTab.grupy[k].dzieci.length; g++  )
                        {
                             
                                for(var r=0; r <  recpientsTab.grupy[k].dzieci[g].rodzice.length; r++ )
                                {

                                    itemsRecpiens.push(
                                        {
                                            v:  recpientsTab.grupy[k].dzieci[g].rodzice[r]["id"],
                                            title:   recpientsTab.grupy[k].dzieci[g].rodzice[r]["nazwisko"] + " " +  recpientsTab.grupy[k].dzieci[g].rodzice[r]["imie"] + " (RODZIC " +  recpientsTab.grupy[k].dzieci[g].dziecko  + " ) " ,
                                        })

                                }

                        }

                }
        }  

        
 
 

    return <div className="view_content">
 
                {
                    props.goBack != null &&
                    <img src={back} onClick={props.goBack} className="back_img" title="wstecz"/>
                }

       

                <form className="eForm bg_center">


                                   <div className="form_tab_title">Odbiorca</div>
  
                                    <div>
                                        {
                                            recpientsTab != null &&
                                            <Fragment>

                                                <div className="form_control">
                                                    <div className="fieldName">Odbiorca wiadomości*</div>
                                                    <InputCombo items={itemsRecpiens} mainView={props.mainView}   userData={props.userData} value={row.odbiorca} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbiorca" placeholder={"Odbiorca:"} className='  ' req='1'   />
                                                </div>

                                            </Fragment>
                                        }
                                    </div>

                                   

                                   <div className="form_control">      
                                        <div className="fieldName">Temat wiadomości</div>
                                        <InputText   userData={props.userData} value={row.temat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="temat" placeholder={"Temat:"} className='w400' req='1'   />
                                    </div>

                                    <div className="form_split">     </div> 

                                    <div className="form_control p95">      
                                        <div className="fieldName">Treść</div>
                                        <InputTextArea   userData={props.userData} value={row.tresc} err={errTab}  valChange={valChangeListener}   name="tresc" placeholder={"Treść:"} className='p100 h100' req='1'   />
                                    </div>


                                    <div className="form_split">     </div> 

                                    <div>
                                        Załączniki ({row.files.length}): 
                                        {
                                            row.files.map( (ff, ix) => {
                                                return <span>
                                                         <b>  {ff.fileName} <sup className="link_color" atr-crypt={ff.crypt} atr-typ="none" atr-typId="-1" onClick={goDeleteAttach}>usuń</sup> </b> &nbsp; &nbsp;
                                                </span>
                                            }   )
                                        }
                                    </div>

                                    <br/>

                                    <div className="form_control">
                                           
                                           <InputUploader   userData={props.userData}  typ="none" typId={"-1"} remove="0" completeUpload={completeUpload} title={ "-dodaj załącznik-" } max_files="10" ext="*/*" />                    
                                                       
                                    </div>


                                  <div className="form_split">     </div> 
                                  <br/>
                                  <div className="form_split">     </div> 

                                    
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={goSend}>Wyślij</div>                                     
                                </div>

                </form>

 
    </div>
}

export default NewMsg;